import * as actionTypes from "./actionTypes";
import {toastr} from "react-redux-toastr";
import {appError, appLoading, appSuccess} from "./appActions";
import {validateAccountApi} from "../../api/registerAccountUrl";
import LocalStorageService from "../../services/LocalStorageService";

export const validateAccountSuccess = (data) => ({
    type: actionTypes.VALIDATE_ACCOUNT_SUCCESS,
    payload: data,
})

export const validateAccountError = (error) => ({
    type: actionTypes.VALIDATE_ACCOUNT_ERROR,
    payload: error,
})

export const validateAccount = (payload) => (dispatch) => {
    const { accountUUID, history, language } = payload;
    dispatch(appLoading());
    validateAccountApi(accountUUID)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(validateAccountSuccess(data));
            toastr.success('INFO', 'validate success');
            const {jwt} = data;
            const service = LocalStorageService.getService();
            service.setToken( jwt );
            service.setAccount(data);
            history.push('/stage2?step=2'+`&lang=${language}`);
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            dispatch(validateAccountError(error));
            if (error && error.response && error.response.data) {
                toastr.error('ERROR', error.response.data.description);
                console.log('Error: ', error.response.data.description);
            } else {
                toastr.error('ERROR: ', "error connected to server");
                console.log('Error: ', 'error connected to server');
            }
            history.push('/not-found');
        });
};
